import { httpInstance } from '@/services/httpInstance';

const deleteFeaturesFlagService = async (promoId) => {
  let res;
  const endpoint = `/back-office/v1/features-flag/${promoId}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteFeaturesFlagService;
